import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'racial-background-questiontype',
  templateUrl: './racial.background.component.html'
})
export class RacialBackgroundComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  formError:false;
  value:'';
  formSegment:FormGroup;
  declinetostate= false;
  asian = false;
  pacificislander= false;
  touched:boolean=false;

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    if(this.required) {
      return !!this.formSegment.controls.selected.value;
    }
    return true;
  }
  validate():boolean {
    this.touched=true;
    return this.isValid();
  }

  ngOnInit() {
    this.touched=false;
    var i,init={};
    init['asian']=new FormControl();
    init['indian']=new FormControl();
    init['burmese']=new FormControl();
    init['cambodian']=new FormControl();
    init['chinese']=new FormControl();
    init['filipino']=new FormControl();
    init['hmong']=new FormControl();
    init['indonesian']=new FormControl();
    init['japanese']=new FormControl();
    init['korean']=new FormControl();
    init['laotian']=new FormControl();
    init['singaporean']=new FormControl();
    init['tahitian']=new FormControl();
    init['thai']=new FormControl();
    init['tongan']=new FormControl();
    init['vietnamese']=new FormControl();
    init['otherasian']=new FormControl();
    init['black']=new FormControl();
    init['americanindian']=new FormControl();
    init['pacificislander']=new FormControl();
    init['guamanian']=new FormControl();
    init['hawaiian']=new FormControl();
    init['samoan']=new FormControl();
    init['otherpacificislander']=new FormControl();
    init['white']=new FormControl();
    init['declinetostate']=new FormControl();
    init['selected']=new FormControl(0);

    this.formSegment=new FormGroup(init);

    if(((typeof this.value)==='object') && (this.value !== null)) {
      for(i in init) {
        if(this.value.hasOwnProperty(i)) {
          init[i].setValue(this.value[i]);
        }
      }
    }
  }

  ngOnDestroy() {
  }

  checkdeclinetostate() {
    if (this.formSegment.controls.declinetostate.value) {
      this.declinetostate = true;
      this.formSegment.controls.asian.setValue(false);
      this.formSegment.controls.black.setValue(false);
      this.formSegment.controls.americanindian.setValue(false);
      this.formSegment.controls.pacificislander.setValue(false);
      this.formSegment.controls.white.setValue(false);
      this.checkasian();
      this.checkpacificislander();
      this.formSegment.controls.selected.setValue(1);
    } else {
      this.declinetostate = false;
      this.formSegment.controls.selected.setValue('');
    }
  }


  checkblack() {
    this.checkselected();
  }

  checkamericanindian() {
    this.checkselected();
  }

  checkwhite() {
    this.checkselected();
  }

  checkasian() {
    if (this.formSegment.controls.asian.value) {
      this.asian = true;
      this.checkselected();
    } else{
      this.asian = false;
      this.checkselected();
      this.formSegment.controls.asian.setValue(false);
      this.formSegment.controls.indian.setValue(false);
      this.formSegment.controls.burmese.setValue(false);
      this.formSegment.controls.cambodian.setValue(false);
      this.formSegment.controls.chinese.setValue(false);
      this.formSegment.controls.filipino.setValue(false);
      this.formSegment.controls.hmong.setValue(false);
      this.formSegment.controls.indonesian.setValue(false);
      this.formSegment.controls.japanese.setValue(false);
      this.formSegment.controls.korean.setValue(false);
      this.formSegment.controls.laotian.setValue(false);
      this.formSegment.controls.singaporean.setValue(false);
      this.formSegment.controls.tahitian.setValue(false);
      this.formSegment.controls.thai.setValue(false);
      this.formSegment.controls.tongan.setValue(false);
      this.formSegment.controls.vietnamese.setValue(false);
      this.formSegment.controls.otherasian.setValue(false);

    }
  }

  checkpacificislander() {
    if (this.formSegment.controls.pacificislander.value) {
      this.pacificislander = true;
      this.checkselected();
    } else {
      this.checkselected();
      this.pacificislander = false;
      this.formSegment.controls.guamanian.setValue(false);
      this.formSegment.controls.hawaiian.setValue(false);
      this.formSegment.controls.samoan.setValue(false);
      this.formSegment.controls.otherpacificislander.setValue(false);
    }
  }

  checkselected() {
    this.touched=true;
    if (this.formSegment.controls.asian.value) {
      this.formSegment.controls.selected.setValue(1);
      this.formSegment.controls.declinetostate.setValue(0);
    } else if (this.formSegment.controls.black.value) {
      this.formSegment.controls.selected.setValue(1);
      this.formSegment.controls.declinetostate.setValue(0);
    } else if (this.formSegment.controls.americanindian.value) {
      this.formSegment.controls.selected.setValue(1);
      this.formSegment.controls.declinetostate.setValue(0);
    } else if (this.formSegment.controls.pacificislander.value) {
      this.formSegment.controls.selected.setValue(1);
      this.formSegment.controls.declinetostate.setValue(0);
    } else if (this.formSegment.controls.white.value) {
      this.formSegment.controls.selected.setValue(1);
      this.formSegment.controls.declinetostate.setValue(0);
    } else if (this.formSegment.controls.declinetostate.value) {
      this.formSegment.controls.selected.setValue(1);
    } else {
      this.formSegment.controls.selected.setValue('');
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/racial.background.component.ts